<template>
    <bordBox :type="'1'">
        <div slot="content" class="data-text">
            <img class="head-img" :src="titleText.memberPic" v-if="listText.length && titleText.memberPic !== ''" />
            <img class="head-img" src="../../assets/img/head.jpg" v-else />
            <div class="title-text" v-if="listText.length">
                <span
                    ><span style="margin-right: 10px">{{ `${titleText.operateTime} ` }}</span> 恭喜
                    <span class="yellow-color">{{ `${titleText.mainHospitalName}/${titleText.branchName}/${titleText.memberName} ` }}</span>
                    成功购买 编号<span class="yellow-color">{{ `${titleText.selectedNumber}` }}</span
                    >玺藏特调版
                </span>
            </div>
            <div class="time-text" v-if="listText.length === 0">
                <div>{{ nowTime }}</div>
            </div>
            <div class="information-data" v-if="listText.length">
                <vue-seamless-scroll :data="listText" class="seamless-warp" ref="seamlessScroll" :class-option="classOption">
                    <ul>
                        <li v-for="(item, index) in listText" :key="index">
                            <span
                                ><span style="margin-right: 10px">{{ `${item.operateTime}` }}</span> 恭喜
                                <span class="yellow-color">{{ `${item.mainHospitalName}/${item.branchName}/${item.memberName} ` }}</span>
                                成功购买 编号<span class="yellow-color">{{ `${item.selectedNumber}` }}</span
                                >玺藏特调版
                            </span>
                        </li>
                    </ul>
                </vue-seamless-scroll>
            </div>
        </div>
    </bordBox>
</template>
<script>
    import bordBox from '../../components/bordBox.vue'
    import bus from '@/utils/bus'
    import vueSeamlessScroll from 'vue-seamless-scroll'
    import signalr from '@/utils/SignalR'

    export default {
        components: { bordBox, vueSeamlessScroll },
        data() {
            return {
                screenWidth: document.body.clientWidth,
                listText: [],
                titleText: null,
                nowTime: '',
                ti: null,
                signalr: new signalr(0)
            }
        },
        mounted() {
            this.signalr.start()
            console.log('signalr', this.$store.state.signalrRes)
            if (this.$store.state.signalrRes) {
                this.getData(this.$store.state.signalrRes)
            }
            this.getNowFormatDate()
            this.ti = setInterval(() => {
                this.getNowFormatDate()
            }, 60000)
            const that = this
            window.onresize = () => {
                return (() => {
                    window.screenWidth = document.body.clientWidth
                    that.screenWidth = window.screenWidth
                })()
            }
        },
        destroyed() {
            window.clearInterval(this.ti)
            this.signalr.stop()
            this.$store.commit('save', null)
        },
        created() {},
        computed: {
            classOption() {
                return {
                    step: 0.3, // 数值越大速度滚动越快
                    limitMoveNum: 5, // 开始无缝滚动的数据量 this.dataList.length
                    hoverStop: true, // 是否开启鼠标悬停stop
                    direction: 1, // 0向下 1向上 2向左 3向右
                    openWatch: true, // 开启数据实时监控刷新dom
                    singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
                    singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
                    waitTime: 500 // 单步运动停止的时间(默认值1000ms)
                }
            }
        },
        watch: {
            /* 监听*/
            screenWidth(val) {
                this.screenWidth = val
                this.width = val * 0.15
                console.log('this.screenWidth', this.screenWidth)
            },
            '$store.state.signalrRes'(newVal, oldVal) {
                if (newVal) {
                    console.log('1', newVal)
                    this.getData(newVal)
                }
            }
        },
        methods: {
            //获取页面实时数据
            getData(res) {
                // let listData = []
                if (res.data.length && res.data[0] !== null) {
                    // this.listText = res.data
                    if (res.push == 1) {
                        const temp = res.data[0]
                        this.listText.splice(0, 0, temp)
                        this.$nextTick(() => {
                            this.$refs.seamlessScroll.reset()
                        })
                        // this.$refs.seamlessScroll.reset()
                        console.log('===>', this.$refs.seamlessScroll)
                        // console.log('zzz', $('.information-data').length)
                    } else {
                        // console.log()
                        this.listText = res.data
                    }
                    this.titleText = this.listText[0]
                }
            },
            //获取当前时间
            getNowFormatDate() {
                var date = new Date()
                var seperator1 = '-'
                var year = date.getFullYear()
                var month = date.getMonth() + 1
                var strDate = date.getDate()
                var hours = date.getHours()
                var minu = date.getMinutes()
                if (month >= 1 && month <= 9) {
                    month = '0' + month
                }
                if (strDate >= 0 && strDate <= 9) {
                    strDate = '0' + strDate
                }
                if (hours >= 0 && hours <= 9) {
                    hours = '0' + hours
                }
                if (minu >= 0 && minu <= 9) {
                    minu = '0' + minu
                }
                var currentdate = year + seperator1 + month + seperator1 + strDate + ' ' + hours + ':' + minu
                this.nowTime = currentdate
            }
        }
    }
</script>
<style lang="scss">
    .seamless-warp {
        width: 100%;
        height: calc(100% - 16px);
        overflow: hidden;
    }
    @media screen and (min-width: 2000px) {
        .head-img {
            width: 180px !important;
            height: 180px !important;
        }
        .title-text {
            font-size: 3rem !important;
        }
        .information-data li {
            font-size: 32px !important;
        }
    }
    @media screen and (min-width: 3000px) {
        .head-img {
            width: 200px !important;
            height: 200px !important;
        }
        .title-text {
            font-size: 4rem !important;
        }
        .information-data li {
            font-size: 40px !important;
        }
    }
    @media screen and (min-width: 4000px) {
        .head-img {
            width: 220px !important;
            height: 220px !important;
        }
        .title-text {
            font-size: 5rem !important;
        }
        .information-data li {
            font-size: 46px !important;
        }
    }
</style>
<style lang="scss" scoped>
    .data-text {
        height: 100%;
        box-sizing: border-box;
        padding: 10% 0;
        text-align: center;
        display: flex;
        flex-direction: column;
        align-items: center;
        .head-img,
        .title-text,
        .time-text {
            flex-shrink: 0;
        }
        .head-img {
            width: 140px;
            height: 140px;
            border: 6px solid #fff;
            border-radius: 50%;
        }
        .title-text {
            margin-top: 25px;
            color: #fff;
            font-size: 2.5rem;
            .yellow-color {
                color: #fed35a;
            }
        }
        .time-text {
            color: #fff;
            font-size: 2rem;
            margin-top: 20px;
        }
        .information-data {
            // height: 40%;
            width: 100%;
            height: 1px;
            flex-grow: 1;
            border-radius: 15px;
            border: 1px solid #ccc;
            margin-top: 6%;
            padding: 15px 20px;
            box-sizing: border-box;
            ul {
                li {
                    height: 20%;
                    // line-height: 100%;
                    margin-top: 1%;
                    color: #fff;
                    font-size: 26px;
                    font-weight: 500;
                    text-align: center;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    .yellow-color {
                        color: #fed35a;
                    }
                }
            }
        }
    }
</style>
